export default {
  props: {
    isVisible: Boolean,
    formattedDate: Array,
    number: Number,
    items: Array,
    totalPrice: Number,
    year: Number,
    count: Number
  }
};